export default () => {
  return new Promise(resolve => {
    if (document.readyState === 'complete') {
      resolve()
    } else {
      window.addEventListener(
        'load',
        () => {
          resolve()
        },
        {
          capture: true,
          once: true,
          passive: true
        }
      )
    }
  })
}
